import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SessionType } from '@shared';
import { selectSession } from '@client/model/selectors';

const ROLE_OVERRIDE_KEY = 'waterlily-role-override';

export function useRoleSwitch() {
  const session = useSelector(selectSession);

  const currentRole = session.sessionType === SessionType.client ? 'client' : 'advisor';
  const isClientMode = currentRole === 'client';

  const switchRole = useCallback(
    (targetRole: 'advisor' | 'client') => {
      if (targetRole === currentRole) return;

      localStorage.setItem(ROLE_OVERRIDE_KEY, targetRole);
      window.location.href = targetRole === 'client' ? '/client/home' : '/advisors';
    },
    [currentRole],
  );

  const toggleRole = useCallback(() => {
    switchRole(isClientMode ? 'advisor' : 'client');
  }, [isClientMode, switchRole]);

  return { currentRole, isClientMode, switchRole, toggleRole };
}
